<app-crudbar [label]="title" (onReady)="doComReady($event,'crudbar')" [editAndSaveVisible]="true">
</app-crudbar>
<div>
  <div class="w-full top-10 border-2  bg-gray-100">
    @if(masterVisible){
    <div class="top-1 border">
      <app-taxpi92 (onFormReady)="doFormReady($event,PageKind.master)">
      </app-taxpi92>
    </div>
    }
    @if(detailVisible){
    <div class="top-1 border border-green-400">
      <app-taxpi92-detail (onFormReady)="doFormReady($event,PageKind.detail)">
      </app-taxpi92-detail>
    </div>
    }
  </div>
<div>
